import { render, staticRenderFns } from "./CompletedJobs.vue?vue&type=template&id=5b2f5e44&"
import script from "./CompletedJobs.vue?vue&type=script&lang=js&"
export * from "./CompletedJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports